module.exports = __webpack_public_path__ + "static/media/apartment2.c28c867e.jpg";